import ExcelJS from "exceljs";

export default function EmployeeExcel(filename, candidateData, invoiceNumber) {
  console.log("candidate data to be seen here console...", candidateData);

  const headings = [
    "EMP ID",
    "EMP NAME",
    "CLIENT",
    "VISA PROVIDER",
    "NATIONALITY",
    "PASSPORT NUMBER",
    "ACTUAL PROFESSION",
    "VISA PROFESSION",
    invoiceNumber.invoice_type === "SEC DEPOSIT"
      ? "SECURITY DEPOSIT COST"
      : "VISA COST",
    "VISA FEE",
    "IQAMA FEE",
    "WORK PERMIT",
    "DRIVING LICENSE",
    "LABOR CARD",
    "INSURANCE",
    "BALADIYAH",
    "AJEER",
    "MEDICAL FOR IQAMA",
    "MUQEEM",
    "PAYROLL CARD",
    "END OF SERVICE",
    "VACATION SALARY",
    "VACATION TICKET",
  ];

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  // Create title row
  const titleRow = sheet.getRow(1);
  titleRow.getCell(1).value = "sno."; // for serial numbers

  for (let i = 0; i <= headings.length; i++) {
    titleRow.getCell(i + 1).style = {
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFF00" }, // Yellow
      },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    titleRow.getCell(i + 2).value = headings[i];
    const column = sheet.getColumn(i + 2);
    column.width = 24;
  }

  sheet.getRow(1).height = 30; // Header height

  // Populate rows with candidateData
  candidateData.forEach((candidate, index) => {
    const row = sheet.getRow(index + 2); // Start from 2nd row
    row.getCell(1).value = index + 1; // Serial number
    row.getCell(2).value = candidate.employee_id;
    row.getCell(3).value = candidate.name;
    row.getCell(4).value = candidate.client;
    row.getCell(5).value = candidate.visa_provider;
    row.getCell(6).value = candidate.nationality;
    row.getCell(7).value = candidate.passport_number;
    row.getCell(8).value = candidate.job_position;
    row.getCell(9).value = candidate.visa_profession;
    row.getCell(10).value =
      invoiceNumber.invoice_type === "SEC DEPOSIT"
        ? candidate.sec_deposit_cost
        : candidate.visa_deposit_cost;
    row.getCell(11).value = candidate.visa_fee;
    row.getCell(12).value = candidate.iqama_fee;
    row.getCell(13).value = candidate.work_permit;
    row.getCell(14).value = candidate.driving_license;
    row.getCell(15).value = candidate.labor_card;
    row.getCell(16).value = candidate.insurance;
    row.getCell(17).value = candidate.baladiyah;
    row.getCell(18).value = candidate.ajeer;
    row.getCell(19).value = candidate.medical_for_iqama;
    row.getCell(20).value = candidate.muqeem;
    row.getCell(21).value = candidate.payroll_card;
    row.getCell(22).value = candidate.end_of_service;
    row.getCell(23).value = candidate.vacation_salary;
    row.getCell(24).value = candidate.vacation_ticket;
    // row.getCell(25).value = candidate.total; // Total amount
  });

  // Generate and download Excel file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename ? `${filename}` : "Candidate_Flight_Details.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  });
}
